var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small",staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('DoughnutChart',{attrs:{"height":270,"chart-data":_vm.chartData,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }